import { Pipe, PipeTransform } from '@angular/core';

import { CriteriaService } from '@app/core/services/criteria/criteria.service';
/**
 * Pipe that returns the list of operators by type like 'number' 'text' 'date'
 *
 * It is mainly used by the SearchInput and Search with filters screens generated by UI Studio tool.
 *
 * This class should not be modified.
 */
@Pipe({
  name: 'operator'
})
export class OperatorPipe implements PipeTransform {

  constructor (private criteriaService: CriteriaService) { }

  transform(value: any[], type: string, columnFilter: boolean = false): Array<string> {
    return this.criteriaService.getOperatorValues(type, columnFilter);
  }
}
